export const isError = (error: unknown): error is Error =>
  typeof error === "object" &&
  error !== null &&
  typeof (error as Error).message === "string";
